import React from "react";
import "../css/PersonalDetails.css";

const PersonalDetails = ({ createdBy, email, contactNumber }) => {
  return (
    <div className="personal-details-container">
      <p>Personal Details</p>
      <div className="personal-details-box">
        <div className="personal-details-row">
          <div className="personal-detail-item">
            <span className="personal-detail-title">Primary Account Owner</span>
            <label>{createdBy || "---"}</label>
          </div>
          <div className="personal-detail-item">
            <span className="personal-detail-title">Contact Number</span>
            <label>{contactNumber || "---"}</label>
          </div>
        </div>
        <hr className="personal-detail-divider" />
        <div className="personal-details-row">
          <div className="personal-detail-item">
            <span className="personal-detail-title">Email</span>
            <label>{email || "---"}</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
